import {Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {FileInputComponent} from "ngx-material-file-input";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {ReceivablesImportsService} from "../../../../shared/services/receivables-imports.service";
import {DOCUMENT} from "@angular/common";
import {Router} from "@angular/router";
import {DictService} from "../../../../shared/services/dict.service";
import {AuthService} from "../../../../shared/services/auth.service";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {FileBase64} from "../../../../shared/components/file-drag-and-drop/file-drag-and-drop.component";
import {delay, first, takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {TerminalsImportService} from "../../../../shared/services/terminals-import.service";

@Component({
  selector: 'app-terminals-import',
  templateUrl: './terminals-import.component.html',
  styleUrls: ['./terminals-import.component.scss']
})
export class TerminalsImportComponent implements OnInit , OnDestroy {
  @ViewChild('fileInput') fileInputComponent: FileInputComponent;

  importForm: FormGroup;
  importFormValid = false;
  fileMaxSize = 5242880 * 20;
  userPermissions: ReplaySubject<UserPermissions>;
  processingRequest = false;
  formErrors = {};


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    private snack: MatSnackBar,
    private formHelper: FormHelperService,
    private terminalsImportService: TerminalsImportService,
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private dictService: DictService,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.importForm = fb.group({
      name: fb.control('', [Validators.required]),
      fileContent: fb.control('', [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.importForm.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        delay(0)
      )
      .subscribe(() => {
        this.importFormValid = this.importForm.valid;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  fileSelected(file: FileBase64): void {
    this.importForm.get('fileContent').setValue(file?.base64);
    this.importForm.get('name').setValue(file?.filename);
  }

  import(): void {
    if (!this.importForm.valid) {
      this.importForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }
    if (this.processingRequest ){
      return;
    }
    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.importForm, this.formErrors);
    this.formErrors = {};
    const formData = {...this.importForm.value};

    this.terminalsImportService.import(formData)
      .pipe(
        first()
      )
      .subscribe(() => {
        this.snack.open('Rozpoczynanie importowania danych', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.router.navigate(['/terminale/raporty']);
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        this.snack.open('Podczas tworzenia importu wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.importForm, this.formErrors);
        }
      })
    ;
  }

}
